module.exports = __webpack_public_path__ + "static/media/Handbag_Thumb_cropped.54404fad.jpg";